import { jsx as M } from "react/jsx-runtime";
import { BadRequest as O } from "@systemeio/util";
import P from "../../../../ui-kit/theme-button.mjs";
import { useStripeApi as _ } from "../../api/stripe-api.mjs";
import { useStripe as x, useElements as D } from "../../../../node_modules/@stripe/react-stripe-js/dist/react-stripe.esm.mjs";
import { getStripeCardConfirmHandler as H } from "../utils/get-stripe-card-confirm-handler.mjs";
import { getStripeCardRequestOptions as R } from "../utils/get-stripe-card-request-options.mjs";
import { useStore as T } from "../../../../store/index.mjs";
import { twJoin as j } from "tailwind-merge";
function L({
  isFetching: f,
  buttonTitle: u,
  buttonDisabled: d,
  setErrors: i,
  setIsFetching: a,
  preSubmit: p,
  handleBadRequest: y,
  hasErrors: w
}) {
  const { locale: h } = T(), { stripeCardBuyOffer: g, confirmPaymentIntent: S } = _(), r = x(), o = D(), b = async (C) => {
    if (C.preventDefault(), !(!r || !o)) {
      a(!0);
      try {
        const t = p();
        if (!t) return;
        const { error: B } = await o.submit();
        if (B) return;
        const { paymentMethod: n, error: m } = await r.createPaymentMethod({
          elements: o,
          params: {
            billing_details: {
              address: {
                country: null,
                line1: null,
                line2: null,
                city: null,
                state: null,
                postal_code: null
              }
            }
          }
        });
        if (m) {
          i((e) => ({
            ...e,
            common: [...e.common, m.message]
          }));
          return;
        }
        if (!n)
          throw Error("undefined payment method");
        const { redirect: s, intentSecret: l, intentType: E } = await g(
          { ...t, options: R(n) },
          h
        );
        if (!l) return window.location.href = s;
        const q = H(r, E), { error: c } = await q(l, {
          payment_method: n.id
        });
        c ? i((e) => ({ ...e, common: [...e.common, c.message] })) : (await S(), window.location.assign(s));
      } catch (t) {
        if (t instanceof O)
          y(t);
        else
          throw t;
      } finally {
        a(!1);
      }
    }
  };
  return /* @__PURE__ */ M(
    P,
    {
      disabled: d,
      className: j("main-transition-colors", w && "bg-danger focus:bg-danger"),
      onClick: b,
      isFetching: f,
      type: "submit",
      children: u
    }
  );
}
export {
  L as StripeCardPaymentButton
};
